var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"webGl"}},[_c('canvas',{attrs:{"id":"glcanvas","width":"100vw","height":"100vh"},on:{"dblclick":function($event){_vm.cycleStyles()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }